import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    setState: ["payload"],
    getData: null
  },
  { prefix: "MENU_" }
);

export const types = Types;
export default Creators;
